import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var divider = {
  label: '',
  style: '',
  type: 'divider',
  icon: ''
};
var CONTROLS = [{
  label: 'Font Size',
  style: 'fontSize',
  type: 'dropdown',
  icon: 'icon-text-size'
}, _objectSpread({}, divider), {
  label: 'Bold',
  style: 'BOLD',
  type: 'inline',
  icon: 'icon-bold'
}, {
  label: 'Italic',
  style: 'ITALIC',
  type: 'inline',
  icon: 'icon-italic'
}, {
  label: 'Underline',
  style: 'UNDERLINE',
  type: 'inline',
  icon: 'icon-underline'
}, {
  label: 'strike',
  style: 'STRIKETHROUGH',
  type: 'inline',
  icon: 'icon-strikethrough'
}, {
  label: 'Link',
  style: 'link',
  type: 'custom',
  icon: 'icon-insert-link'
}, {
  label: 'Clear Formatting',
  style: 'clearFormatting',
  type: 'custom',
  icon: 'icon-clear-formatting'
}, _objectSpread({}, divider), {
  label: 'Text Alignment',
  style: 'textAlignment',
  type: 'dropdown',
  icon: 'icon-left-aligned'
}, {
  label: 'UL',
  style: 'unordered-list-item',
  icon: 'icon-bulleted-list'
}, {
  label: 'OL',
  style: 'ordered-list-item',
  icon: 'icon-numbered-list'
}, _objectSpread({}, divider), {
  label: 'Undo',
  style: 'undo',
  type: 'custom',
  icon: ''
}, {
  label: 'Redo',
  style: 'redo',
  type: 'custom',
  icon: ''
}];
export default CONTROLS;